import { Check, Sparkles } from "lucide-react";

export const SetCompletionCheck = () => {
  return (
    <div className="animate-fade-in flex flex-col items-center justify-center py-12">
      {/* Decorative sparkles */}
      <div className="absolute">
        <Sparkles className="h-6 w-6 text-yellow-400 absolute -top-8 -left-8 animate-pulse" />
        <Sparkles className="h-4 w-4 text-yellow-400/60 absolute -top-4 left-12 animate-pulse delay-100" />
        <Sparkles className="h-5 w-5 text-yellow-400/80 absolute top-8 -right-10 animate-pulse delay-200" />
      </div>

      <div className="relative w-36 h-36 flex items-center justify-center mb-6">
        {/* Outer glow ring */}
        <div className="absolute inset-0 bg-gradient-to-br from-green-400/30 to-emerald-500/30 rounded-full animate-[pulse_2s_ease-in-out_infinite] blur-xl" />
        
        {/* Middle ring */}
        <div className="absolute inset-2 bg-gradient-to-br from-green-400/20 to-emerald-500/20 rounded-full animate-[pulse_2s_ease-in-out_infinite_0.3s]" />
        
        {/* Inner circle with icon */}
        <div className="relative rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center w-24 h-24 shadow-2xl shadow-green-500/40 animate-scale-in">
          <Check className="h-14 w-14 text-white drop-shadow-lg" strokeWidth={3} />
        </div>
      </div>

      <div className="text-center space-y-2">
        <p className="text-3xl font-bold bg-gradient-to-r from-green-400 via-emerald-400 to-green-500 bg-clip-text text-transparent">
          ¡Serie Completada!
        </p>
        <p className="text-muted-foreground text-sm">
          Sigue así, vas muy bien
        </p>
      </div>
    </div>
  );
};
